import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Want to know exactly what's driving your bill? Create a dashboard with the `}<a parentName="p" {...{
        "href": "/templates/posthog-billable-usage"
      }}>{`PostHog billable usage template`}</a>{` to break down and analyze your usage across different events, SDK libraries, and products.`}</p>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/posthog_billable_usage_b2b494d4bb.png" imageDark="https://res.cloudinary.com/dmukukwp6/image/upload/posthog_billable_usage_b2b494d4bb.png" alt="PostHog billable usage dashboard" classes="max-w-md mx-auto rounded" mdxType="ProductScreenshot" />
    <p>{`This dashboard turns your billing usage into a live, interactive report — so you can create insights, spot spikes, and optimize how you're spending.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      